import {Component, OnInit} from "@angular/core";
import {select} from "@angular-redux/store";
import {Observable} from "rxjs/Observable";
import {IUser} from "../../../../shared/redux-store/session/session.types";
import {TouchMenuService} from "../touch-menu.service";
import {VbMenuEntry} from "../menu-item.interface";
import {Router} from '@angular/router';

@Component({
  selector: 'vb-touch-navbar',
  templateUrl: './touch-navbar.component.html',
  styleUrls: ['./touch-navbar.component.css']
})
export class TouchNavbarComponent implements OnInit {

  @select(['session', 'user'])
  currentUser$: Observable<IUser>;

  activeEntries$: Observable<VbMenuEntry[]>;

  constructor(private touchMenuService: TouchMenuService, private router: Router) {
    this.activeEntries$ = this.touchMenuService.activeMenuEntries$;
  }

  ngOnInit() {

  }

  onReloadClicked() {
    this.router.navigate(['/'])
      .then(res => window.location.reload(true))
      .catch(err => window.location.reload(true));
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/navigation/touch-navbar/touch-navbar.component.ts